export const THEME_BUILDER_API_URL = 'https://wpp-app-theme-builder-api-ch-stage.os-dev.io' || 'http://localhost:8080'
